module.exports = __webpack_public_path__ + "img/zrfg-active.d87090f6.svg";